var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{ref:"adSupported",attrs:{"value":_vm.value,"items":_vm.adSupported,"rules":_vm.rules.adSupported,"label":"Ad Supported","data-cy":"ad-supported"},on:{"change":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }